<template>
	<div class="copyright-box">
		<div class="swiper-item">
			<p>北京研发中心：
			<br>北京市朝阳区望京科技创业园F座3层302室 (010)84148525</p>
			<p>苏州工厂总部：
			<br>江苏省苏州市常熟经济技术开发区高新技术产业园盘锦北路9号 (0512)52212600</p>
			<p>Copyright © 2017-2023 金仕生物科技（常熟）有限公司			<br>All Rights Reserved. 			<br>苏ICP备17025049号</p>
			<p>客服热线（工作时间 8:30-17:30）</p>
			<p class="tel"><a href="tel:4008-567-100">4008-567-100</a></p>
			<p>客服邮箱
			<br><a href="mailto:kingstronbio@kingstronbio.com">kingstronbio@kingstronbio.com</a></p>
			<p>招商电话
			<br><a href="tel:4008-567-100">4008-567-100</a></p>
			<p class="shareCode">
				<img src="../../../static/code.jpg" /><br/>
				金仕生物微信公众号
			</p>
			<!-- <p>金仕生物微信公众号</p> -->
		</div>
	</div>
</template>

<script>
	export default {
		name: 'copyright',
		data() {
			return {
				
			}
		},
		mounted() {
		},
		methods: {
			
		},
	}
</script>

<style lang="less" scoped>
@import url('@/assets/css/index.less');
	@media only screen and (min-aspect-ratio: ~'486/814'){
		.swiper-item {
			top: 80/@r !important;
			font-size:36/@r !important;
			p {
				margin-bottom:0 !important;
			}
			.tel {
				font-size:46/@r !important;
				margin: 0 auto !important;
			}
			.tab-title {
				margin:20/@r 0 !important;
			}
			.shareCode{
				width:826/@r;
				img{
					width: 300/@r !important;
					display: inline-block;
				}
			}
		}
	}
	@media only screen and (min-aspect-ratio: ~'506/848'){
		.swiper-item {
			top: 80/@r !important;
			font-size:36/@r !important;
			p {
				margin-bottom:0 !important;
			}
			.tel {
				font-size:46/@r !important;
				margin: 0 auto !important;
			}
		}
	}
	.copyright-box {
		background-color: #fff;
		width: 100%;
		height: 100%;
		.swiper-item {
			width:826/@r;
			.pos-a-center(120);
			font-size:42/@r;
			color:#4d4d4d;
			p {
				margin-bottom:40/@r;
				a{
					color:#4d4d4d !important;
				}
			}
			
			.tel {
				font-size:70/@r;
				font-weight: bold;
				margin: 0 auto;
			}
			.tab-title {
				font-weight:bold;
				margin:40/@r 0;
			}
			.shareCode{
				width:826/@r;
				text-align: center;
				img{
					width: 360/@r;
					display: inline-block;
				}
				// .pos-a-center(200);
			}
		}
	}
</style>